import {
  metaNameClassName,
  postProfileClassName,
  profileMetaClassName,
} from './styles';

export interface Props {
  name: string;
}

const CardPostProfile = ({ name }: Props) => {
  return (
    <div className={postProfileClassName}>
      <div className={profileMetaClassName}>
        <span className={metaNameClassName}>{name}</span>
      </div>
    </div>
  );
};

CardPostProfile.displayName = 'CardPostProfile';

export default CardPostProfile;
